import React from 'react';
import { Modal, ModalBody, Button, Spinner, Alert } from 'reactstrap';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'supports/api';

const OnlineCourseSessionFormModal = ({
  isOpen,
  toggle,
  onlineCourseModuleId,
  selectedCourseSession,
  lastOrderNumber,
  refresh,
}) => {
  const validationSchema = Yup.object().shape({
    order: Yup.string().required('Wajib diisi'),
    title: Yup.string().required('Wajib diisi'),
  });

  const initialValues = {
    order: selectedCourseSession?.order,
    title: selectedCourseSession?.title,
  };

  const onSubmit = async (values) => {
    try {
      if (selectedCourseSession?.id) {
        await axios.put(
          `/v2/online-course/module/${onlineCourseModuleId}/session/${selectedCourseSession?.id}`,
          {
            title: values.title.trim(),
            order: values.order,
          },
        );
      } else {
        await axios.post(
          `/v2/online-course/module/${onlineCourseModuleId}/session`,
          {
            title: values.title.trim(),
            order: lastOrderNumber + 1,
          },
        );
      }

      refresh();
    } catch (err) {
      console.log(err);
      alert(err);
    }
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalBody>
        <Formik
          validationSchema={validationSchema}
          initialValues={initialValues}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="d-flex flex-column">
                <label htmlFor="title" className="font-weight-bold">
                  Judul Session
                </label>
                <Field
                  name="title"
                  placeholder="Input judul disini"
                  className="form-control mb-2"
                />
                <ErrorMessage
                  name="title"
                  render={(msg) => <Alert color="danger">{msg}</Alert>}
                />
                <label htmlFor="order" className="font-weight-bold">
                  Order Session
                </label>
                <Field
                  name="order"
                  placeholder="Input order disini"
                  className="form-control mb-2"
                />
                <ErrorMessage
                  name="order"
                  render={(msg) => <Alert color="danger">{msg}</Alert>}
                />
                <Button
                  type="submit"
                  color="success"
                  style={{ backgroundColor: '#32b280' }}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? <Spinner /> : 'Submit'}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

export default OnlineCourseSessionFormModal;
